import {
  MoreItem,
  useNavigationHeader,
} from "@/src/common/navigationHeaderOptions";

import { Box } from "arkh";
import React from "react";

import { IntegrationHeader } from "./IntegrationHeader";
import { IntegrationInput } from "./IntegrationInput";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { SafeAreaView } from "react-native-safe-area-context";
import { useNavigation } from "@react-navigation/native";

export function IntegrationSettings(props: {
  header: React.ReactNode;
  body?: React.ReactNode;
  delete?: {
    pending: boolean;
    requestDelete: () => void;
  };
  save?: {
    pending: boolean;
    requestSave: () => void;
    disabled: boolean;
  };
}) {
  const intl_tokens = useIntlTokens();
  const moreItems: MoreItem[] = props.delete
    ? [
        {
          label: intl_tokens.Delete,
          onPress: () => {
            props.delete?.requestDelete();
          },
          color: "negative",
          icon: "trash",
          type: "button",
        },
      ]
    : [];

  const navigation = useNavigation();
  useNavigationHeader(
    props.save
      ? {
          type: "SAVE",
          onCancel: () => {
            navigation.goBack();
          },
          saveLoading: props.save.pending,
          disabled: props.save.disabled,
          onSave: () => {
            props.save?.requestSave();
          },
          more: moreItems,
        }
      : {
          type: "BACK",
          more: moreItems,
        }
  );

  return (
    <Box style={{ flex: 1 }} color="surface-background-light">
      <SafeAreaView style={{ flex: 1 }}>
        {props.header}
        <Box space="medium" style={{ flex: 1 }}>
          {props.body}
        </Box>
      </SafeAreaView>
    </Box>
  );
}

IntegrationSettings.Header = IntegrationHeader;
IntegrationSettings.Input = IntegrationInput;
